module.exports = __webpack_public_path__ + "media/home/coffee-flight-42d536d9.png";